export const initialState = {
  promosList: [],
  isBeta: false,
  optinInfo: {}
};

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case "PROMOS_LIST_SET": {
      return { ...state, promosList: action.payload };
    }
    case "SET_BETA_OPTIN": {
      return { ...state, isBeta: action.payload };
    }
    case "SET_OPTIN_INFO": {
      return { ...state, optinInfo: action.payload };
    }
    default: {
      return state;
    }
  }
};

export default appReducer;
